// src/config/firebase.ts - SINGLE INSTANCE
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { resolveFirebaseAuthDomain } from './firebaseAuthDomain';

const configuredAuthDomain =
  import.meta.env['VITE_FIREBASE_AUTH_DOMAIN'] || 'label-doctor-f255e.firebaseapp.com';

const firebaseConfig = {
  apiKey: import.meta.env['VITE_FIREBASE_API_KEY'] || "AIzaSyCRvP4mK5dIcIdiCCMudJeHtp4QZ1gYcmg",
  authDomain: resolveFirebaseAuthDomain(
    configuredAuthDomain,
    typeof window === 'undefined' ? undefined : window.location.hostname,
  ),
  projectId: import.meta.env['VITE_FIREBASE_PROJECT_ID'] || "label-doctor-f255e",
  storageBucket: import.meta.env['VITE_FIREBASE_STORAGE_BUCKET'] || "label-doctor-f255e.firebasestorage.app",
  messagingSenderId: import.meta.env['VITE_FIREBASE_MESSAGING_SENDER_ID'] || "830455001644",
  appId: import.meta.env['VITE_FIREBASE_APP_ID'] || "1:830455001644:web:aa0f2e345d52250c83d789",
  measurementId: import.meta.env['VITE_FIREBASE_MEASUREMENT_ID'] || "G-10MEGV5WLL"
};

// SINGLE INSTANCE - prevent multiple apps
let app;
if (getApps().length === 0) {
  if (import.meta.env.DEV) {
    console.log('🔥 Creating FIRST Firebase app');
  }
  app = initializeApp(firebaseConfig);
} else {
  if (import.meta.env.DEV) {
    console.log('🔥 Using EXISTING Firebase app');
  }
  app = getApps()[0];
}

if (!app) {
  throw new Error('Failed to initialize Firebase app');
}

export const auth = getAuth(app);
export default app;

// NOTE: never log the `auth` object itself — the console holds a live
// reference, so expanding it in devtools reaches currentUser.stsTokenManager.
if (import.meta.env.DEV) {
  console.log('✅ Firebase SINGLETON initialized:', { app: app.name });
}

// Add to window for debugging (development only)
if (import.meta.env.DEV) {
  (window as any).auth = auth;
  console.log('🌍 window.auth set globally for debugging');
}
